import { ICreatePerson, IPerson } from './person.dto';

export class CompanyEmployeeDto {
  id: number;
  person: IPerson;
  position?: string;
  createdAt: Date;
}

export class CreateCompanyEmployeeDto {
  person: ICreatePerson;
  position?: string;
}
